import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
@Injectable({
  providedIn: "root",
})
export class ScheduleListService {
  constructor(private https: HttpClient, public errorService: ErrorService) {}

  //................................. UpdateScheduleAppointment.................................
  UpdateScheduleAppointment(save: any, gridtype, radiotype): Observable<any> {
    let url =
      gridtype == "childgrid"
        ? "api/VisitSchedule/UpdateScheduleAppointments"
        : radiotype == "enterseries"
        ? "api/VisitSchedule/UpdateVisitSchedule"
        : "api/VisitSchedule/UpdateSelectedDateAppointment";

    return this.https
      .post(url, save, { observe: "response"})
      .pipe(
        map((data) => data.body),
        catchError(this.errorService.handleError)
      );
  }

  //................................. DeleteAppointment.................................
  DeleteAppointment(params): Observable<any> {
    let url = "api/VisitSchedule/DeleteAppointment?";
    return this.https
      .delete(url + params, { observe: "response", responseType: "text" })
      .pipe(
        map((data) => data.body),
        catchError(this.errorService.handleError)
      );
  }
  //................................. DeleteVisitSchedule.................................
  DeleteVisitSchedule(params): Observable<any> {
    let url = "api/VisitSchedule/DeleteSchedule?";
    return this.https
      .delete(url + params, { observe: "response", responseType: "text" })
      .pipe(
        map((data) => data.body),
        catchError(this.errorService.handleError)
      );
  }
  DeleteSelectedDateAppointments(params): Observable<any> {
    let url = "api/VisitSchedule/DeleteSelectedAppointments?";
    return this.https
      .delete(url + params, { observe: "response", responseType: "text" })
      .pipe(
        map((data) => data.body),
        catchError(this.errorService.handleError)
      );
  }
}
